/* eslint-disable no-nested-ternary */
import { Toggle } from "components/ui/Toggle";
import { TextTooltip } from "components/ui/Tooltip";
import classNames from "components/ui/classNames";
import aspectRatio from "components/utils/aspectRatio";
import type { SVGProps } from "react";
import { useIntl } from "react-intl";

interface PrimarySymbolToggleProps {
  isPrimaryTickerSymbol: boolean;
  disabled?: boolean;
  onChange: (isPrimaryTickerSymbol: boolean) => void;
}
export function PrimarySymbolToggle({ isPrimaryTickerSymbol, disabled, onChange }: PrimarySymbolToggleProps) {
  const intl = useIntl();
  return (
    <TextTooltip
      asChild={true}
      side="top"
      align="center"
      delayDuration={1000}
      sideOffset={4}
      contentClassName="font-bold"
      content={
        isPrimaryTickerSymbol
          ? intl.formatMessage({ defaultMessage: "Exibindo somente os tickers mais líquidos", id: "X45grN" })
          : intl.formatMessage({ defaultMessage: "Exibindo todos os tickers", id: "8lGuTj" })
      }
    >
      <Toggle
        aria-label={intl.formatMessage({
          defaultMessage: "Usar código de negociação principal",
          id: "xy+6lE",
        })}
        pressed={isPrimaryTickerSymbol}
        onPressedChange={(value) => {
          onChange(value);
        }}
        disabled={disabled}
        className={classNames("size-9 rounded-xl p-1 ring-1 ring-inset", {
          "bg-violet-50 text-violet-700 ring-violet-300 hover:border-violet-400": isPrimaryTickerSymbol,
          "bg-slate-50 text-slate-500 ring-slate-300 hover:border-slate-400 hover:bg-violet-100 hover:text-violet-700":
            !isPrimaryTickerSymbol,
          "dark:bg-teal-700/70 dark:text-teal-50 dark:ring-transparent": isPrimaryTickerSymbol,
          "dark:bg-gray-700 dark:text-gray-300 dark:ring-slate-900 dark:hover:bg-teal-400/20 dark:hover:text-teal-50":
            !isPrimaryTickerSymbol,
        })}
      >
        <PrimarySymbolToggleIcon
          {...aspectRatio({
            originalWidth: 25.801,
            originalHeight: 25.459,
            desiredWidth: 24,
          })}
        />
      </Toggle>
    </TextTooltip>
  );
}

const PrimarySymbolToggleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={25.801} height={25.459} xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 25.801 25.459">
    <path
      d="M25.44 12.725c0 7.002-5.713 12.714-12.725 12.714C5.713 25.44 0 19.727 0 12.725 0 5.713 5.713 0 12.715 0c7.012 0 12.724 5.713 12.724 12.725ZM9.931 6.787c-.567 0-.87.41-.87 1.006v9.824c0 .586.313.996.88.996.585 0 .908-.39.908-.996v-3.115h2.675c2.422 0 4.053-1.553 4.053-3.857 0-2.286-1.65-3.858-4.043-3.858H9.932Zm5.888 3.858c0 1.503-.986 2.47-2.51 2.47h-2.46V8.174h2.46c1.514 0 2.51.976 2.51 2.47Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
